module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-root"
  }, [_c('general-title', {
    attrs: {
      "title": "人群属性",
      "description": "分析访客行为，包括性别、年龄、学历和职业。通过人群画像来定位网站的核心用户",
      "pos": "right",
      "date": _vm.timeSpan
    }
  }), _c('CompTimeSpan', {
    attrs: {
      "mintspan": 7,
      "compared": _vm.compared
    },
    on: {
      "rangeChange": _vm.resetCompared,
      "compRangeChange": _vm.compRangeChange
    }
  }), _c('div', {
    staticClass: "zone top-zone"
  }, [_c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.3333%"
    }
  }, [_c('div', {
    staticClass: "mr20"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-user-o",
      "title": "性别比例"
    }
  }), _c('PieChart', {
    attrs: {
      "fromAttr": _vm.fromAttr,
      "legend": _vm.genderLegend,
      "comp": _vm.compared,
      "series": _vm.gender_series,
      "option": _vm.pieConf,
      "loading": _vm.genderLoading
    }
  })], 1)]), _c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.3333%"
    }
  }, [_c('div', {
    staticClass: "mr20"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-leaf",
      "title": "年龄分布"
    }
  }), _c('BarChart', {
    attrs: {
      "comp": _vm.compared,
      "initXAxis": _vm.ageXAxis,
      "legend": _vm.commonLegend,
      "series": _vm.age_series,
      "dir": "vertical",
      "color": _vm.ageColor,
      "loading": _vm.ageLoading
    }
  })], 1)]), _c('div', {
    staticClass: "top-zone-cell",
    attrs: {
      "width": "33.3333%"
    }
  }, [_c('div', [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-graduation-cap",
      "title": "学历分布"
    }
  }), _c('BarChart', {
    attrs: {
      "comp": _vm.compared,
      "initXAxis": _vm.eduXAxis,
      "legend": _vm.commonLegend,
      "series": _vm.edu_series,
      "dir": "vertical",
      "color": _vm.eduColor,
      "loading": _vm.eduLoading
    }
  })], 1)])]), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-briefcase",
      "title": "职业分布"
    }
  }), _c('BarChart', {
    attrs: {
      "comp": _vm.compared,
      "initXAxis": _vm.jobInitXAxis,
      "legend": _vm.commonLegend,
      "color": _vm.jobColor,
      "series": _vm.job_series,
      "dir": "vertical",
      "loading": _vm.jobLoading
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d390479e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d390479e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/attributes.vue
// module id = 799
// module chunks = 0